<div class="modal fade" id="jobTitleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" [dir]="isRtl? 'rtl': 'ltr'">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        @if(jobDetails){
            <div class="modal-content">
                <div class="modal-header" style="background-color: var(--identity-primary-400);">
                    <h4 class="modal-title text-white">{{ 'jobClassification.jobTicket' | translate : { job: isRtl ? jobDetails.nameAr : jobDetails.name } }}</h4>
                </div>
                <div class="modal-body">
                    <div class="card">
                    <div class="card-body">
                        <label class="label" translate="jobClassification.jobTitle"></label>
                        <p class="fs-6 lh-base">{{isRtl ? jobDetails.nameAr : jobDetails.name}}</p>
                        <label class="label" translate="jobClassification.summary"></label>
                        <p class="fs-6 lh-base">{{isRtl ? jobDetails.summaryAr :
                        jobDetails.summary}}</p>
                    </div>
                    </div>
                    <div class="w-100 my-3"
                    *ngIf="jobDetails.noteAr || jobDetails.relatedExperiences">
                    <h6 translate="jobClassification.relatedJob"></h6>
                    <ul class="list-group p-0">
                        <li *ngFor="let jobs of stringSpliter(isRtl? jobDetails.noteAr : jobDetails.note, '-')"
                        class="list-group-item text-break">
                        {{ jobs }}
                        </li>
                        <li
                        *ngFor="let jobs of stringSpliter(jobDetails.relatedExperiences, ',')"
                        class="list-group-item text-break">
                        {{ jobs }}
                        </li>
                    </ul>
                    </div>
                    <div class="w-100 my-3"
                    *ngIf="jobDetails.jobResponsibilities?.length > 0">
                    <h6 translate="jobClassification.Responsibilities"></h6>
                    <ul class="list-group p-0">
                        <li
                        *ngFor="let responsibility of jobDetails.jobResponsibilities"
                        class="list-group-item text-break fs-6 lh-base">
                        {{ isRtl?  responsibility.responsibilityAr: responsibility.responsibility }}
                        </li>
                    </ul>
                    </div>
                    <div class="w-100 my-3"
                    *ngIf="getSkillsByType(getSkillTypeEnum.Technical)?.length > 0">
                    <h6 translate="skills.type.Technical"></h6>
                    <ul class="list-group p-0">
                        <li
                        *ngFor="let skill of getSkillsByType(getSkillTypeEnum.Technical)"
                        class="list-group-item text-break fs-6 lh-base">
                        {{ isRtl? skill.nameAr: skill.name }}
                        </li>
                    </ul>
                    </div>
                    <div class="w-100 my-3"
                    *ngIf="getSkillsByType(getSkillTypeEnum.GeneralTechnical)?.length > 0">
                    <h6 translate="skills.type.GeneralTechnical"></h6>
                    <ul class="list-group p-0">
                        <li
                        *ngFor="let skill of getSkillsByType(getSkillTypeEnum.GeneralTechnical)"
                        class="list-group-item text-break fs-6 lh-base">
                        {{isRtl ? skill.nameAr : skill.name }}
                        </li>
                    </ul>
                    </div>
                    <div class="w-100 my-3"
                    *ngIf="getSkillsByType(getSkillTypeEnum.Behaviorism)?.length > 0">
                    <h6 translate="skills.type.Behaviorism"></h6>
                    <div class="table-responsive">
                        <table class="table table-condensed">
                        <thead>
                            <tr>
                            <th class="rounded-0" [ngClass]="isRtl? 'text-end': 'text-start'" translate="jobClassification.skill"></th>
                            <th class="rounded-0" [ngClass]="isRtl? 'text-end': 'text-start'" translate="jobClassification.level"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                            *ngFor="let skill of getSkillsByType(getSkillTypeEnum.Behaviorism)">
                            <td class="" [ngClass]="isRtl? 'text-end': 'text-start'">{{isRtl? skill.nameAr : skill.name}}</td>
                            <td class="" [ngClass]="isRtl? 'text-end': 'text-start'">{{skill.level}}</td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                    </div>
                </div>
            </div>
        }
    </div>
</div>